import { c as _c } from "react/compiler-runtime";
import { getEntitiesByFpIdBusinessOwnersOptions } from '@onefootprint/fetch-dashboard';
import { IcoBuilding16 } from '@onefootprint/icons';
import type { Entity } from '@onefootprint/request-types/dashboard';
import { useQuery } from '@tanstack/react-query';
import { useTranslation } from 'react-i18next';
import useDocuments from '@/entity/hooks/use-documents';
import AddressFieldset from '../address-fieldset';
import CustomDataFields from '../custom-data-fields';
import DocumentFieldset from '../document-fieldset';
import Fieldset from '../fieldset';
import GridLayout, { type Section, SectionKeys } from '../grid-layout';
import useFieldsets from './hooks/use-fieldsets';
import BusinessOwners from './hooks/use-fieldsets/components/business-owners';
type BusinessVaultProps = {
  entity: Entity;
};
const BusinessVault = t0 => {
  const $ = _c(32);
  const {
    entity
  } = t0;
  let t1;
  if ($[0] === Symbol.for("react.memo_cache_sentinel")) {
    t1 = {
      keyPrefix: "vault"
    };
    $[0] = t1;
  } else {
    t1 = $[0];
  }
  const {
    t
  } = useTranslation("business-details", t1);
  const {
    basic,
    address,
    custom
  } = useFieldsets();
  let t2;
  if ($[1] !== entity.id) {
    t2 = getEntitiesByFpIdBusinessOwnersOptions({
      path: {
        fpId: entity.id
      }
    });
    $[1] = entity.id;
    $[2] = t2;
  } else {
    t2 = $[2];
  }
  const bosQuery = useQuery(t2);
  const {
    data: documents
  } = useDocuments(entity.id);
  const hasDocuments = !!documents && documents.length > 0;
  let t3;
  if ($[3] !== bosQuery.data) {
    t3 = bosQuery.data?.some(_temp);
    $[3] = bosQuery.data;
    $[4] = t3;
  } else {
    t3 = $[4];
  }
  const hasBos = !!t3;
  let t4;
  if ($[5] !== entity.data) {
    t4 = entity.data.some(_temp2);
    $[5] = entity.data;
    $[6] = t4;
  } else {
    t4 = $[6];
  }
  const hasCustomData = t4;
  let t5;
  if ($[7] !== basic.fields || $[8] !== basic.iconComponent || $[9] !== basic.title) {
    t5 = {
      key: SectionKeys.BASIC,
      content: <Fieldset fields={basic.fields} iconComponent={basic.iconComponent} title={basic.title} />
    };
    $[7] = basic.fields;
    $[8] = basic.iconComponent;
    $[9] = basic.title;
    $[10] = t5;
  } else {
    t5 = $[10];
  }
  let t6;
  if ($[11] !== entity || $[12] !== hasBos || $[13] !== t) {
    t6 = hasBos && {
      key: SectionKeys.BUSINESS_OWNERS,
      content: <Fieldset fields={[]} iconComponent={IcoBuilding16} title={t(_temp3)}><BusinessOwners entity={entity} /></Fieldset>
    };
    $[11] = entity;
    $[12] = hasBos;
    $[13] = t;
    $[14] = t6;
  } else {
    t6 = $[14];
  }
  let t7;
  if ($[15] !== address.fields || $[16] !== address.iconComponent || $[17] !== address.title) {
    t7 = {
      key: SectionKeys.ADDRESS,
      content: <AddressFieldset fields={address.fields} iconComponent={address.iconComponent} title={address.title} />
    };
    $[15] = address.fields;
    $[16] = address.iconComponent;
    $[17] = address.title;
    $[18] = t7;
  } else {
    t7 = $[18];
  }
  let t8;
  if ($[19] !== custom || $[20] !== entity || $[21] !== hasCustomData) {
    t8 = hasCustomData && {
      key: SectionKeys.CUSTOM,
      content: <CustomDataFields entity={entity} title={custom.title} iconComponent={custom.iconComponent} />
    };
    $[19] = custom;
    $[20] = entity;
    $[21] = hasCustomData;
    $[22] = t8;
  } else {
    t8 = $[22];
  }
  let t9;
  if ($[23] !== documents || $[24] !== hasDocuments) {
    t9 = hasDocuments && {
      key: SectionKeys.DOCUMENTS,
      content: <DocumentFieldset documents={documents} />
    };
    $[23] = documents;
    $[24] = hasDocuments;
    $[25] = t9;
  } else {
    t9 = $[25];
  }
  let t10;
  if ($[26] !== t5 || $[27] !== t6 || $[28] !== t7 || $[29] !== t8 || $[30] !== t9) {
    const sections = [t5, t6, t7, t8, t9].filter(_temp4);
    t10 = <GridLayout sections={sections} />;
    $[26] = t5;
    $[27] = t6;
    $[28] = t7;
    $[29] = t8;
    $[30] = t9;
    $[31] = t10;
  } else {
    t10 = $[31];
  }
  return t10;
};
export default BusinessVault;
function _temp(bo) {
  return bo.ownershipStake != null;
}
function _temp2(attr) {
  return attr.identifier.startsWith("custom");
}
function _temp3($) {
  return $.bos.title;
}
function _temp4(section) {
  return Boolean(section);
}